import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import img from 'images/live/live.svg';
import CloseButton from 'shared/components/button/CloseButton';
import { getText } from 'shared/utils/Text';
import { getUrl } from 'shared/utils/urls';

import styles from './index.module.scss';

const Announce = () => {
  const [visible, setVisible] = useState(true);
  const toggleVisible = () => setVisible(!visible);

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.closeContainer}>
        <CloseButton border={false} large onClick={toggleVisible} />
      </div>

      <Link className={styles.container} to={getUrl.live()}>
        <div className={styles.imgContainer}>
          <div className={styles.newTag}>{getText('new-tag')}</div>
          <img alt="" className={styles.img} src={img} />
        </div>

        <div className={styles.texts}>
          <div className={styles.header}>
            {getText('page-live-announce-header')}
          </div>

          <div className={styles.details}>
            {getText('page-live-announce-details')}
          </div>
        </div>
      </Link>
    </div>
  );
};

Announce.propTypes = {
  onClose: PropTypes.func,
};

export default Announce;
